import type { ApolloError } from '@apollo/client';

export const hasAuthError = (error?: ApolloError) =>
  Boolean(
    error?.graphQLErrors.filter(
      ({ extensions }) => extensions?.code === 'UNAUTHENTICATED',
    ).length,
  );
